<template>
  <div class="grid">
    <div class="options pill-hover">
      <router-link ref="djsLink" to="/djs" class="pill">
        <div class="toggle-container">
          <img src="@/assets/images/dubby.png" class="toggle-image" />
          <h1>Residents</h1>
        </div>
      </router-link>
      <router-link ref="showsLink" to="/shows" class="pill">
        <div class="toggle-container">
          <img src="@/assets/images/lil_speaker_guy.png" class="toggle-image" />
          <h1>Shows</h1>
        </div></router-link
      >
    </div>

    <div :class="['grid-auto-md', { 'a-hover': djs }]">
      <ArchiveThumb
        v-for="item in filteredItemsIsActive"
        :key="item.url"
        :page="item"
        class="center"
        :circle="true"
      ></ArchiveThumb>
    </div>
    <div class="heading-djs-shows">{{ pastText }}</div>
    <div :class="['grid-auto-md', { 'a-hover': djs, inactive: true }]">
      <div v-for="(item, index) in filteredItemsNotActive" :key="index">
        <div class="inner-container" :key="index">
          <router-link :to="item.url">
            <p>{{ item.title }}</p>
          </router-link>
          <span
            v-if="index !== filteredItemsNotActive.length - 1"
            :key="item"
            class="custom-comma"
            >&nbsp;&#x2022;&nbsp;
          </span>
        </div>
      </div>
    </div>
    <BoxDonate></BoxDonate>
  </div>
</template>

<script>
import { mixin } from "@/lib/content-state";
import ArchiveThumb from "@/components/ArchiveThumb";
import BoxDonate from "@/components/BoxDonate";

export default {
  name: "ViewResidents",
  components: { ArchiveThumb, BoxDonate },
  mixins: [mixin],

  computed: {
    djs() {
      return this.$route.name === "djs";
    },
    filteredItemsIsActive() {
      return this.pages.filter((item) => {
        return item.is_active === true || item.is_active === null;
      });
    },
    filteredItemsNotActive() {
      const filteredItems = this.pages.filter((item) => {
        return item.is_active === false && item.is_active !== null;
      });
      return filteredItems;
    },
    broadcastDate() {
      return false;
    },
    pastText() {
      return this.djs ? "Past Resident DJs" : "Past Shows";
    },
  },
};
</script>

<style scoped>
.options {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  grid-column: 1 / -1;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 3rem;
}

.heading-djs-shows {
  font: var(--medium);
  -webkit-font-smoothing: antialiased;
  -webkit-box-direction: normal;
  background-repeat: no-repeat;
  box-sizing: inherit;
  grid-column: 1 / -1;
  width: 100%;
  border-top: solid;
  border-bottom: solid;
  position: relative;
  display: inline-block;
  padding: var(--p1);
  background-color: white;
  color: black;
  text-align: center;
  margin: var(--py1);
  margin-top: 20px;
  border-width: 1px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 30px;
}

.inactive {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  grid-gap: unset;
  grid-template-columns: unset;
  justify-content: center;
  padding: 0 24px 0 24px;
  gap: 3px;
}

.ArchiveThumb.dj,
.ArchiveThumb.event {
  font: var(--large);
}

.toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.toggle-container h1 {
  font-size: 30px;
}

a:not(.active) > .toggle-container h1:hover {
  color: #0287fe;
}

.toggle-image {
  height: 40px;
  width: 40px;
}

.inner-container {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.inner-container:hover {
  color: #0287fe;
}

.inner-container * {
  font-size: 26px;
}

@media (max-width: 1000px) {
  .inactive {
    padding: 0 5px 0 5px;
    gap: 0;
  }
  .inner-container * {
    font-size: 20px;
  }

  .toggle-container h1 {
    font-size: 20px;
  }
}
</style>
